import { useMemo } from 'react';
import { useAppData } from '../context/AppDataContext';

/**
 * useSensorsOptimized — now a thin wrapper around the global AppDataContext.
 *
 * Previously this hook fetched sensor data on every page mount (3+ DB queries
 * + per-sensor reading fetches). Now it reads from the shared cache that's
 * fetched once on login and refreshed by a single background poll.
 *
 * The optional zoneFilter narrows the already-cached list in memory — no
 * extra network calls.
 *
 * API is unchanged so existing pages don't need modifications.
 */
export const useSensorsOptimized = (zoneFilter = null) => {
  const { sensors, sensorsLoading, sensorsError, refreshSensors } = useAppData();

  // Filter in memory when a zoneFilter is given — no re-fetch.
  const filteredSensors = useMemo(() => {
    if (!zoneFilter) return sensors;
    return sensors.filter((s) => s.zone_id === zoneFilter);
  }, [sensors, zoneFilter]);

  return {
    sensors: filteredSensors,
    isLoading: sensorsLoading,
    error: sensorsError,
    refetch: refreshSensors,
  };
};

export default useSensorsOptimized;
